/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Lifecycle state of a prompt. Only `active` prompts are served to end users; `inactive` prompts stay in the admin library and are never displayed. These are wire values — clients render their own display text.
 */
export enum SamplePromptStatus {
    ACTIVE = 'active',
    INACTIVE = 'inactive',
}
